
import { useEffect, useState } from "react";
import { useSession } from "../session/Context";
import { toast } from "react-toastify";
import API from "../Api";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'

interface ApiKeyCardProps {
    data: any,
    updateData: (newData:any) => void
    deleteData: () => void
}

export default function ApiKeyCard(props:ApiKeyCardProps) {

    const [show, setShow] = useState(false);
    const { brand, } = useSession();

    const removeApi = (id:any, name:any): void => {

        let url = "/api/v1";
        if (brand !== "") {
            url += "/brand/" + brand + "/access-token";
        } else {
            url += "/brand/root/access-token";
        }
        
        API(url, {
            method: "DELETE",
            body: id,
        })
        .then((resp) => {
            toast.success("Successfully removed API key "+ name, { theme: "colored" });
            props.deleteData();
        })
        .catch((e) => {
            toast.error("Error " + e, { theme: "colored" });
            console.error(e);
        });
    };

    
    const onEnableDisable = (id:any, el:any ): void => {

        let url = "/api/v1";
        if (brand !== "") {
            url += "/brand/" + brand + "/access-token";
        } else {
            url += "/brand/root/access-token";
        }
        
        API(url, {
            method: "POST",
            body: JSON.stringify({
                type: el ? "disallow" : "allow",  token: id
            })
        })
        .then((resp) => {
            toast.success("Updated API key ", { theme: "colored" });

            // update data
            props.data.allow = !props.data.allow;
            props.updateData(props.data);
        })
        .catch((e) => {
            toast.error("Error " + e, { theme: "colored" });
            console.error(e);
        });
    };

    
    return (<>
        
        <div className=" fun-fact-card container_credential"  id={"card:"+props.data.access_token} key={"credential_"+props.data.access_token} >
            <div className="first_box" style={{}}>
                <div className="timeline timeline-second-style clearfix"  /*onClick={() => credentialDetails(item["id"])}*/>
                    <div className="timeline-item clearfix">
                        <div className="left-part">
                            <h5 className="item-period">Key</h5>
                        </div>
                        
                        <div className="right-part">
                            <h4 className="item-title">{props.data.name}</h4>
                        </div>

                        <div className="elementUnpublish2" >
                            <button className="btn btn-primary" onClick={() => onEnableDisable(props.data.access_token, props.data.allow)}>{props.data.allow ? "Disable" : "Allow"}</button>
                            <button className="btn btn-primary" onClick={() => removeApi(props.data.access_token, props.data.name)}>Remove</button>
                        </div>
                        
                    </div>

                    <div className="timeline-item clearfix">
                        <div className="left-part">
                            <h5 className="item-period">Access token</h5>
                        </div>

                        <div className="right-part">
                            <span style={{  wordBreak: "break-all"}}>{show ? props.data.access_token : "*****"}</span>
                        </div>

                        <div className="elementUnpublish2" >
                            <button className="btn btn-primary"onClick={() => setShow(!show)}><FontAwesomeIcon icon={show ?  faEye : faEyeSlash }></FontAwesomeIcon></button>
                        </div>
                    </div>
                </div> 

            </div>
        </div>
        
    </>);
}
